var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.0262,
    cy: 11.0262,
    r: 11.0262,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 10.9595C7.25 9.42764 7.25 8.66118 7.72613 8.1856C8.20171 7.70947 8.96817 7.70947 10.5 7.70947H12.125C13.6568 7.70947 14.4233 7.70947 14.8989 8.1856C15.375 8.66118 15.375 9.42764 15.375 10.9595V13.6678C15.375 15.1996 15.375 15.9661 14.8989 16.4417C14.4233 16.9178 13.6568 16.9178 12.125 16.9178H10.5C8.96817 16.9178 8.20171 16.9178 7.72613 16.4417C7.25 15.9661 7.25 15.1996 7.25 13.6678V10.9595Z",
    stroke: "#626262",
    strokeWidth: 0.8125
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 15.2928C6.81902 15.2928 6.4057 15.1216 6.10095 14.8169C5.7962 14.5121 5.625 14.0988 5.625 13.6678V10.4178C5.625 8.37518 5.625 7.3536 6.25983 6.71931C6.89467 6.08501 7.91571 6.08447 9.95833 6.08447H12.125C12.556 6.08447 12.9693 6.25568 13.274 6.56042C13.5788 6.86517 13.75 7.2785 13.75 7.70947",
    stroke: "#626262",
    strokeWidth: 0.8125
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.fb32ef95dd82ba07b883f0cee2abd8ba.svg";
export { ForwardRef as ReactComponent };